import AccountMainLayout from '../Layout/AccountMainLayout';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getApi } from '../utils/api';
import { generatePrice } from '../utils/helpers';
import {
  coverage,
  membershipCardApi,
  packages,
  rangeBookingListApi,
} from '../utils/endpoint';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import moment from 'moment';
import { ThreeDots } from 'react-loader-spinner';
import ErrorBanner from './ErrorBanner';
import Pagination from '../components/Pagination';

const BOOKINGS_PER_PAGE = 10;

const AccountCoverage = () => {
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [primaryPlan, setPrimaryPlan] = useState({});
  const [upcomingInvoice, setUpcomingInvoice] = useState({});
  const [rangeSearchLocation, setRangeSearchLocation] = useState('');
  const [bookings, setBookings] = useState([]);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [bookingsError, setBookingsError] = useState('');
  const [bookingsHasFetched, setBookingsHasFetched] = useState(false);
  const [bookingsPage, setBookingsPage] = useState(1);
  const [bookingsTotal, setBookingsTotal] = useState(0);
  const [bookingsStatus, setBookingsStatus] = useState('');
  const [bookingsDate, setBookingsDate] = useState('');
  const [view, setView] = useState(false);
  const [modal, setModal] = useState(false);
  const { personalDetail } = useSelector((state) => state.signup);
  const navigate = useNavigate();
  const access_token = Cookies.get('userToken');

  useEffect(() => {
    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      navigate('/plans');
    }
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getApi(coverage, access_token)
      .then((res) => {
        if (res?.data?.success) {
          setPrimaryPlan(res?.data?.data?.plan);
          setPlanYearly(
            res?.data?.data?.plan?.subscriptionInterval === 'month'
              ? 'Monthly'
              : 'Yearly'
          );
          setSelectedPackages(res?.data?.data?.packages);
          setUpcomingInvoice(res?.data?.data?.upcomingInvoice);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!personalDetail?.id) {
      return;
    }

    setBookingsLoading(true);
    setBookingsError('');

    const queryParams = new URLSearchParams({
      shotpro_user_id: personalDetail.id,
      status: bookingsStatus,
      per_page: String(BOOKINGS_PER_PAGE),
      page: String(bookingsPage),
    });

    if (bookingsDate) {
      queryParams.append('date', moment(bookingsDate).format('YYYY-MM-DD'));
    }

    getApi(`${rangeBookingListApi}?${queryParams.toString()}`, access_token)
      .then((res) => {
        if (res?.data?.success) {
          const bookingPayload = res?.data?.data;
          const bookingRows = Array.isArray(bookingPayload)
            ? bookingPayload
            : Array.isArray(bookingPayload?.data)
              ? bookingPayload.data
              : [];
          const totalCount =
            bookingPayload?.total ||
            bookingPayload?.meta?.total ||
            res?.data?.total ||
            bookingRows.length;

          setBookings(bookingRows);
          setBookingsTotal(totalCount);
          return;
        }

        setBookings([]);
        setBookingsTotal(0);
        setBookingsError(
          res?.data?.message || 'Unable to load range bookings.'
        );
      })
      .catch((err) => {
        setBookings([]);
        setBookingsTotal(0);
        setBookingsError(
          err?.response?.data?.message || 'Unable to load range bookings.'
        );
      })
      .finally(() => {
        setBookingsLoading(false);
        setBookingsHasFetched(true);
      });
  }, [
    access_token,
    bookingsDate,
    bookingsPage,
    bookingsStatus,
    personalDetail?.id,
  ]);

  const [plan, setPlan] = useState([]);
  const [planYearly, setPlanYearly] = useState('Monthly');
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedPlanPackage, setSelectedPlanPackage] = useState({});
  const [, setSelectedPackage] = useState({});
  // const [total, setTotal] = useState(0);
  const [, setSelectedStripeIds] = useState([]);
  // console.warn(selectedStripeIds, selectedPackage);
  let packagePlan = localStorage.getItem('selectedPlan');
  let selectedPlan = packagePlan ? JSON.parse(packagePlan) : plan;
  const [isLoading, setIsLoading] = useState(false);
  const [isCardDownloading, setIsCardDownloading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErrorDetail, setShowErrorDetail] = useState({
    isError: true,
    message: '',
  });

  const handleDownloadMembershipCard = async (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!access_token) {
      setShowErrorDetail({
        isError: true,
        message: 'Your session has expired. Please log in again.',
      });
      setShowError(true);
      return;
    }

    if (isCardDownloading) {
      return;
    }

    setIsCardDownloading(true);

    try {
      const response = await getApi(membershipCardApi, access_token, null, {
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf',
        },
      });

      const fileBlob = response?.data;
      const contentDisposition = response?.headers?.['content-disposition'];
      let fileName = 'membership-card.pdf';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(
          /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
        );
        if (fileNameMatch) {
          fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
        }
      }

      if (!fileBlob) {
        throw new Error('Unable to download membership card.');
      }

      const fileUrl = URL.createObjectURL(fileBlob);
      const downloadLink = document.createElement('a');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      // Delay revocation to avoid cancelling download in some browsers.
      setTimeout(() => {
        URL.revokeObjectURL(fileUrl);
      }, 1000);
    } catch (_error) {
      setShowErrorDetail({
        isError: true,
        message: 'Unable to download membership card. Please try again.',
      });
      setShowError(true);
    } finally {
      setIsCardDownloading(false);
    }
  };

  const handleRangeSearchRedirect = () => {
    const trimmedLocation = rangeSearchLocation.trim();

    navigate(
      trimmedLocation
        ? `/find-a-range?location=${encodeURIComponent(trimmedLocation)}`
        : '/find-a-range'
    );
  };

  const handleRangeSearchKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleRangeSearchRedirect();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      getApi(packages)
        .then((res) => {
          setPlan(res.data?.data[0]);
          let packagePlan = res.data?.data[0]?.packages[0];
          let data = {};
          data.planName = packagePlan.name + ' Monthly';
          data.id = packagePlan.id;

          let stripeArray = [];
          const matchingPrice = packagePlan?.package_prices.find(
            (item) =>
              item.price_frequency === planYearly && item.is_prepaid === false
          );

          if (matchingPrice) {
            data.planPrice = Number(matchingPrice.price);
            data.priceFrequency = matchingPrice.price_frequency;
            data.stripeId = matchingPrice.stripe_price_id;
            stripeArray.push(matchingPrice.stripe_price_id);
          }
          setSelectedPackage({
            billingOption: data,
          });
          setSelectedStripeIds(stripeArray);

          if (selectedPackages.length > 0) {
            let packages = res.data?.data[0]?.packages;
            const addonIdsSet = new Set(
              selectedPackages.map((addon) => addon.id)
            );
            const defaultCheckedItems = packages
              ?.filter(
                (item) =>
                  item.add_on !== 0 &&
                  item.name !== 'Additional Associate Coverage'
              )
              ?.reduce((acc, item, index) => {
                acc[index] = addonIdsSet.has(item.id);
                return acc;
              }, {});
            setSelectedPlanPackage(defaultCheckedItems);
            setCheckedItems(defaultCheckedItems);
          }
        })
        .catch((er) => {
          console.log(er);
        });
    };
    fetchData();
  }, [modal]);

  // useEffect(() => {
  //   let planAmount = selectedPackage?.billingOption
  //     ? selectedPackage?.billingOption?.planPrice
  //     : 0;
  //   let addonAmount = selectedPackage?.addonPrice
  //     ? selectedPackage?.addonPrice
  //     : 0;
  //   let additionalAddonAmount = selectedPackage?.additionalAddon
  //     ? selectedPackage?.additionalAddon
  //     : 0;
  //   let sum =
  //     Number(planAmount) + Number(addonAmount) + Number(additionalAddonAmount);
  //   setTotal(Number(sum));
  // }, [selectedPackage]);

  const handleCheckboxChange = (data, index) => {
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [index]: !prevCheckedItems[index],
    }));
    let customData = {
      id: data.id,
    };
    let price, stripeId;
    const matchingPrice = data.package_prices.find(
      (item) => item.price_frequency === planYearly && item.is_prepaid === false
    );

    if (matchingPrice) {
      price = Number(matchingPrice.price);
      customData.planName = data.name + ' ' + matchingPrice.price_frequency;
      customData.planPrice = matchingPrice.price;
      customData.priceFrequency = matchingPrice.price_frequency;
      customData.stripeId = matchingPrice.stripe_price_id;
      stripeId = matchingPrice.stripe_price_id;
    }

    setSelectedPackage((prevItems) => {
      const newAddons = prevItems.addons ? [...prevItems.addons] : [];
      const isDataInArray = newAddons.includes(customData);

      if (isDataInArray) {
        const filteredAddons = newAddons.filter((item) => item !== customData);
        let sum;

        sum = prevItems.addonPrice - price;
        return {
          ...prevItems,
          addons: filteredAddons,
          addonPrice: sum,
        };
      } else {
        const updatedAddons = [...newAddons, customData];
        let sum = prevItems.addonPrice ? prevItems.addonPrice : 0;
        sum = sum + price;
        return {
          ...prevItems,
          addons: updatedAddons,
          addonPrice: sum,
        };
      }
    });

    setSelectedStripeIds((prevItems) => {
      const newId = prevItems ? [...prevItems] : [];
      const isDataInArray = newId.includes(stripeId);
      if (isDataInArray) {
        const filteredId = newId.filter((item) => item !== stripeId);
        return filteredId;
      } else {
        return [...prevItems, stripeId];
      }
    });
  };

  const handleReview = () => {
    if (Object.values(selectedPlanPackage).every((value) => value === true)) {
      setShowError(true);
      setShowErrorDetail({
        isError: false,
        message: 'All add-on are already added.',
      });
      setTimeout(() => {
        setShowError(false);
        setShowErrorDetail({
          isError: true,
          message: '',
        });
      }, 3000);
    }
  };

  const handleClose = () => {
    setShowError(false);
    setShowErrorDetail({
      isError: true,
      message: '',
    });
  };
  const handleCancel = () => {
    if (selectedPackages.length > 0) {
      let packages = plan?.packages;
      const addonIdsSet = new Set(selectedPackages.map((addon) => addon.id));
      const defaultCheckedItems = packages
        ?.filter(
          (item) =>
            item.add_on !== 0 && item.name !== 'Additional Associate Coverage'
        )
        ?.reduce((acc, item, index) => {
          acc[index] = addonIdsSet.has(item.id);
          return acc;
        }, {});
      setSelectedPlanPackage(defaultCheckedItems);
      setCheckedItems(defaultCheckedItems);
    }
  };

  const handleBookingsDateChange = (e) => {
    setBookingsDate(e.target.value);
    setBookingsPage(1);
  };

  const handleBookingsStatusChange = (e) => {
    setBookingsStatus(e.target.value);
    setBookingsPage(1);
  };

  const handleBookingsPageChange = (pageNumber) => {
    setBookingsPage(pageNumber);
  };

  const shouldShowBookingsLoader = bookingsLoading && !bookingsHasFetched;

  const memberName =
    personalDetail?.name ||
    [personalDetail?.first_name, personalDetail?.last_name]
      .filter(Boolean)
      .join(' ') ||
    'User';

  const memberSinceSource = primaryPlan?.start_date;

  const memberSinceText =
    memberSinceSource && moment(memberSinceSource).isValid()
      ? moment(memberSinceSource).format('MMMM YYYY')
      : memberSinceSource;

  const membershipId = primaryPlan?.id || 'CC-48291';

  const packageTitle = primaryPlan?.name
    ? `${primaryPlan.name} Package Plan`
    : 'Lifetime Package Plan';

  const membershipStatus =
    String(primaryPlan?.status) === '1' ? 'Active' : 'Inactive';

  const validThruText =
    primaryPlan?.end_date && moment(primaryPlan.end_date).isValid()
      ? moment(primaryPlan.end_date).format('MMMM DD, YYYY')
      : primaryPlan?.subscriptionInterval === 'month' ||
          primaryPlan?.subscriptionInterval === 'year'
        ? upcomingInvoice?.period_end
          ? moment.unix(upcomingInvoice.period_end).format('MMMM DD, YYYY')
          : 'Lifetime'
        : 'Lifetime';

  const planFeatures = Array.isArray(primaryPlan?.plan?.features)
    ? primaryPlan.plan.features
    : [];

  const fallbackBenefits = [
    {
      name: 'Discounted Range Fees',
      description:
        'Save 50-80% at every partner range. Applied automatically at checkout.',
      iconClass: 'fa fa-shield',
      hasBadge: false,
    },
    {
      name: 'Hearing & Eye Protection',
      description:
        'Complimentary safety gear at all participating partner ranges.',
      iconClass: 'fa fa-eye',
      hasBadge: false,
    },
    {
      name: '127 Partner Ranges',
      description:
        'Your member benefits travel with you. Works at all partner ranges nationwide.',
      iconClass: 'fa fa-info-circle',
      hasBadge: false,
    },
    {
      name: '2 Guest Passes / Month',
      description:
        'Bring a guest to any partner range at no additional charge.',
      iconClass: 'fa fa-users',
      hasBadge: true,
    },
    {
      name: 'Priority Lane Access',
      description:
        'Skip the wait. Priority reservations at all partner ranges.',
      iconClass: 'fa fa-star',
      hasBadge: true,
    },
    {
      name: 'Vendor Discounts',
      description:
        'Exclusive pricing on Wiley-X, SIG Sauer, and all partner vendors.',
      iconClass: 'fa fa-book',
      hasBadge: true,
    },
  ];

  const mappedBenefits =
    planFeatures.length > 0
      ? planFeatures.map((feature, index) => ({
          name:
            feature?.name ||
            fallbackBenefits[index % fallbackBenefits.length].name,
          description:
            feature?.description ||
            fallbackBenefits[index % fallbackBenefits.length].description,
          iconClass:
            fallbackBenefits[index % fallbackBenefits.length].iconClass,
          hasBadge: index >= 3,
        }))
      : fallbackBenefits;

  const formatBookingDate = (value) => {
    if (!value) {
      return '--';
    }

    const parsedDate = moment(
      value,
      ['DD-MM-YYYY', 'YYYY-MM-DD', 'MM/DD/YYYY', moment.ISO_8601],
      true
    );

    if (parsedDate.isValid()) {
      return parsedDate.format('DD MMMM, YYYY');
    }

    const fallbackDate = moment(value);
    return fallbackDate.isValid()
      ? fallbackDate.format('DD MMMM, YYYY')
      : value;
  };

  const formatBookingTime = (value) => {
    if (!value) {
      return '--';
    }

    const parsedTime = moment(
      value,
      ['h:mm A', 'h:mm a', 'HH:mm', 'HH:mm:ss', moment.ISO_8601],
      true
    );

    if (parsedTime.isValid()) {
      return parsedTime.format('hh:mm A');
    }

    const fallbackTime = moment(value);
    return fallbackTime.isValid() ? fallbackTime.format('hh:mm A') : value;
  };

  const getParticipantCount = (booking) => {
    if (booking?.no_of_participants) {
      return booking.no_of_participants;
    }

    if (!booking?.participant_json) {
      return '--';
    }

    try {
      const parsedParticipants = JSON.parse(booking.participant_json);
      return Array.isArray(parsedParticipants)
        ? parsedParticipants.length
        : '--';
    } catch (_error) {
      return '--';
    }
  };

  return (
    <>
      <AccountMainLayout>
        <div className="account-login pt-5 px-0 d-none">
          {isLoading && (
            <div className="loader">
              <ThreeDots
                height="110"
                width="110"
                radius="10"
                color="#aeaeae"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: 'contents' }}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
          {!isLoading && (
            <>
              {showError && (
                <ErrorBanner
                  error={showErrorDetail}
                  handleClose={handleClose}
                />
              )}
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card user-card 6">
                      <div className="card-header">
                        <h4>
                          {primaryPlan && primaryPlan?.name
                            ? primaryPlan?.name.toUpperCase() +
                              ' ' +
                              (primaryPlan?.subscriptionInterval &&
                              primaryPlan?.subscriptionInterval === 'month'
                                ? 'MONTHLY'
                                : primaryPlan?.subscriptionInterval === 'year'
                                  ? 'YEARLY'
                                  : '') +
                              ' PLAN'
                            : 'Loading...'}
                        </h4>
                        <h4 className="date-select">
                          VALID THRU :
                          <span className="ps-1">
                            {primaryPlan?.subscriptionInterval !== 'month' &&
                              primaryPlan?.subscriptionInterval !== 'year' &&
                              'Lifetime'}
                            {upcomingInvoice &&
                              (primaryPlan?.subscriptionInterval === 'month' ||
                                primaryPlan?.subscriptionInterval === 'year') &&
                              upcomingInvoice?.next_payment_attempt &&
                              moment
                                .unix(upcomingInvoice?.period_end)
                                .format('MMMM DD, YYYY')
                                .toUpperCase()}
                          </span>
                        </h4>
                      </div>

                      <div className="row">
                        <div className="col-lg-6">
                          <div className="coverage-yearly">
                            <div className="logo-cover">
                              <img src="../images/brand_emblem.svg" alt="" />
                              <div className="cover-text order-first order-md-last">
                                <h5>
                                  {primaryPlan &&
                                    primaryPlan?.name +
                                      ' ' +
                                      (primaryPlan?.subscriptionInterval &&
                                      primaryPlan?.subscriptionInterval ===
                                        'month'
                                        ? 'Monthly'
                                        : primaryPlan?.subscriptionInterval ===
                                            'year'
                                          ? 'Yearly'
                                          : '')}
                                </h5>
                                <p>
                                  {primaryPlan &&
                                    primaryPlan?.subscribedPrice && (
                                      <>
                                        {generatePrice(
                                          primaryPlan?.subscribedPrice / 100
                                        )}
                                        {primaryPlan?.subscriptionInterval ===
                                        'month'
                                          ? '/month'
                                          : primaryPlan?.subscriptionInterval ===
                                              'year'
                                            ? '/year'
                                            : '/one-time'}
                                      </>
                                    )}
                                </p>
                              </div>
                            </div>

                            {/* <h5>Benefits Included</h5>
                            <ul className="user-list-gun">
                              {primaryPlan &&
                                primaryPlan?.plan?.features?.map(
                                  (item, index) => {
                                    if (index < 3) {
                                      return (
                                        <li key={index}>
                                          <span>{item?.name}</span>
                                          <span>
                                            <img
                                              src="../images/check.svg"
                                              alt=""
                                            />
                                          </span>
                                        </li>
                                      );
                                    } else if (view) {
                                      return (
                                        <li key={index}>
                                          <span>{item?.name}</span>
                                          <span>
                                            <img
                                              src="../images/check.svg"
                                              alt=""
                                            />
                                          </span>
                                        </li>
                                      );
                                    }
                                  }
                                )}
                              <div className="click-button">
                                <button
                                  type="button"
                                  className="view"
                                  onClick={() => setView(!view)}
                                >
                                  View {view ? 'Less' : 'Full'} Plan Benefits
                                </button>
                              </div>
                            </ul> */}
                          </div>
                        </div>
                        <div className="col-lg-6 ">
                          <div className="coverage-yearly">
                            <h5>Benefits Included</h5>
                            <ul className="user-list-gun">
                              {primaryPlan &&
                                primaryPlan?.plan?.features?.map(
                                  (item, index) => {
                                    if (index < 3) {
                                      return (
                                        <li key={index}>
                                          <span>{item?.name}</span>

                                          <img
                                            src="../images/check-mark.png"
                                            alt=""
                                          />
                                        </li>
                                      );
                                    } else if (view) {
                                      return (
                                        <li key={index}>
                                          <span>{item?.name}</span>
                                          <img
                                            src="../images/check-mark.png"
                                            alt=""
                                          />
                                        </li>
                                      );
                                    }
                                  }
                                )}
                              <div className="click-button">
                                <Link
                                  to="#"
                                  type="button"
                                  className="link-text"
                                  onClick={() => setView(!view)}
                                >
                                  {view ? 'Read Less' : 'Read More'}
                                </Link>
                              </div>
                            </ul>
                            <div className=" d-none">
                              <h3 className="additional-heading">
                                Additional Coverage
                              </h3>
                              <ul className="additional-menu-list">
                                {selectedPackages &&
                                  selectedPackages?.map((item, index) => (
                                    <li key={index}>
                                      - {item?.name} -{' '}
                                      {generatePrice(
                                        item?.subscribedPrice / 100
                                      )}
                                      /
                                      {item?.subscriptionInterval === 'month'
                                        ? 'month'
                                        : 'year'}
                                    </li>
                                  ))}
                                {!selectedPackages && <li>Loading....</li>}
                                <h3 className="additional-heading-2">
                                  Optional Add-on Coverage
                                </h3>
                              </ul>
                              <button
                                type="button"
                                className="button-golden w-100 py-3 login-button"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={() => setModal(true)}
                              >
                                upgrade coverage
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-user-id-number card-spacing-mobile mt-3">
                    <div className="row">
                      <div className="col-lg-12 mt-4">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="outer-account-heading">
                            <h2 className="account-heading">Reservations</h2>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-6 mb-3 mb-md-0">
                              <input
                                type="date"
                                className="form-control d-none"
                                placeholder="Select Date"
                                value={bookingsDate}
                                onChange={handleBookingsDateChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <select
                                className="form-select d-none"
                                value={bookingsStatus}
                                onChange={handleBookingsStatusChange}
                              >
                                <option value="">Select Status</option>
                                <option value="Pending">Pending</option>
                                <option value="Scheduled">Scheduled</option>
                                <option value="Completed">Completed</option>
                                <option value="active">Active-Good</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="card card-table">
                          <table className="table-list mobile-responsive table-use-list">
                            <thead>
                              <tr>
                                <th>BOOKING ID</th>
                                <th>RANGE NAME</th>
                                <th>DATE</th>
                                <th>START TIME</th>
                                <th>PARTICIPANTS</th>
                                <th>SKILL LEVEL</th>
                                <th>FIREARM</th>
                              </tr>
                            </thead>
                            <tbody>
                              {shouldShowBookingsLoader ? (
                                <tr>
                                  <td data-label="RANGE NAME" colSpan="7">
                                    <div className="d-flex justify-content-center py-3">
                                      <ThreeDots
                                        height="35"
                                        width="35"
                                        radius="9"
                                        color="#aeaeae"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ) : bookingsError ? (
                                <tr>
                                  <td
                                    data-label="RANGE NAME"
                                    colSpan="7"
                                    className="text-center text-danger py-3"
                                  >
                                    {bookingsError}
                                  </td>
                                </tr>
                              ) : bookings.length > 0 ? (
                                bookings.map((item, index) => (
                                  <tr
                                    key={item?.id || item?.booking_id || index}
                                  >
                                    <td data-label="BOOKING">
                                      {item?.booking_id || item?.id || '--'}
                                    </td>
                                    <td data-label="RANGE NAME">
                                      {item?.range_name ||
                                        item?.range?.name ||
                                        item?.rangeName ||
                                        '--'}
                                    </td>
                                    <td data-label="DATE">
                                      {formatBookingDate(item?.date)}
                                    </td>
                                    <td data-label="START TIME">
                                      {formatBookingTime(
                                        item?.time || item?.start_time
                                      )}
                                    </td>
                                    <td data-label="PARTICIPANTS">
                                      {getParticipantCount(item)}
                                    </td>
                                    <td data-label="SKILL LEVEL">
                                      {item?.skill_level ||
                                        item?.skillLevel ||
                                        '--'}
                                    </td>
                                    <td data-label="FIREARM">
                                      {item?.firearm || '--'}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    data-label="RANGE NAME"
                                    colSpan="7"
                                    className="text-center py-3"
                                  >
                                    No bookings found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {!bookingsError && bookingsTotal > 0 && (
                          <Pagination
                            itemsPerPage={BOOKINGS_PER_PAGE}
                            totalItems={bookingsTotal}
                            currentPage={bookingsPage}
                            onPageChange={handleBookingsPageChange}
                            disabled={bookingsLoading}
                          />
                        )}
                      </div>
                      <div className="col-lg-12">
                        <div className="member-doc">
                          <ul className="mem-doc">
                            <li>Membership Documents</li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="member-doc mt-0">
                          <ul className="mem-doc mb-5">
                            <li className="font d-none">
                              Membership ID Card{' '}
                              <a onClick={handleDownloadMembershipCard}>
                                Download
                              </a>
                            </li>
                            <li className="font">
                              Membership ID Card{' '}
                              <a onClick={handleDownloadMembershipCard}>
                                Download
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="safety">
                <div className="container-fluid">
                  <div className="row align-items-center">
                    <div className="col-lg-6 g-0">
                      <div className="shooting mt">
                        <img src="../images/hero82.webp" alt="" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="safety-text">
                        <h3 className="sub-title">HANDGUN SAFETY</h3>
                        <p>
                          The Basics of Handgun Safety are the foundation upon
                          which all other aspects of being a responsible gun
                          owner rely upon. Download your exclusive safety manual
                          now!
                        </p>
                        <Link
                          // to="https://cdn.shopify.com/s/files/1/0645/6069/3505/files/Right_To_Bear_Member_Exclusive_Handgun_Safety_Booklet.pdf?v=1661348472"
                          className="button-golden py-3 px-5 login-button"
                          // target="_blank"
                          to="#"
                        >
                          Download Now
                        </Link>
                      </div>
                      <img
                        src="../images/line.svg"
                        alt=""
                        className="img-fluid line-tine d-none"
                      />
                    </div>
                    <div className="col-lg-6 g-0">
                      <div className="shooting mt-img">
                        <img src="../images/Screenshot.png" alt="" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="safety-text">
                        <h3 className="sub-title">KNOW THE LAW</h3>
                        <p>
                          Part of being prepared is knowing the letter of the
                          law for how and when you can carry a firearm. Download
                          our concealed carry restrictions pamphlet for a state
                          by state breakdown!
                        </p>
                        <Link
                          // to="https://cdn.shopify.com/s/files/1/0645/6069/3505/files/RTB_Carry_Restrictions_By_State.pdf?v=1663097585"
                          className="button-golden py-3 px-5 login-button"
                          // target="_blank"
                        >
                          Download Now
                        </Link>
                      </div>
                      <img
                        src="../images/line.svg"
                        alt=""
                        className="img-fluid line-tine d-none"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="exampleModal"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg size-modal">
                  <div className="modal-content billing-list">
                    <div className="modal-header billing-heading">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Change Reservations
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={handleCancel}
                      ></button>
                    </div>
                    <div className="modal-body billing-body">
                      <div className="row">
                        {selectedPlan.packages
                          ?.filter(
                            (item) =>
                              item.add_on !== 0 &&
                              item.name !== 'Additional Associate Coverage'
                          )
                          ?.map((item, index) => (
                            <div className="col-md-6 col-lg-4" key={index}>
                              {item.package_prices
                                ?.filter(
                                  (item) => item.price_frequency === planYearly
                                )
                                .map((price, ind) => (
                                  <div
                                    className={
                                      selectedPlanPackage[index]
                                        ? 'form-group disabled'
                                        : 'form-group'
                                    }
                                    key={ind}
                                  >
                                    <input
                                      type="checkbox"
                                      name="cab_booking"
                                      id={'later' + index}
                                      className="check-box-list"
                                      onChange={() =>
                                        handleCheckboxChange(item, index)
                                      }
                                      disabled={selectedPlanPackage[index]}
                                      checked={checkedItems[index]}
                                    />
                                    <label
                                      htmlFor={'later' + index}
                                      className="later-book book-name"
                                    >
                                      {item.name}
                                      {planYearly === 'Yearly'
                                        ? ' Yearly '
                                        : ' Monthly '}
                                      - ${price.price}
                                    </label>
                                  </div>
                                ))}
                            </div>
                          ))}

                        {/* <h4 className="people py-4">ADD PEOPLE</h4>
                  {selectedPlan.packages
                    ?.filter(
                      (item) => item.name === "Additional Associate Coverage"
                    )
                    .map((_package, index) => (
                      <div className="col-md-12 col-lg-6 mb-4" key={index}>
                        {_package.package_prices
                          ?.filter(
                            (item) => item.price_frequency === planYearly
                          )
                          .map((price, ind) => (
                            <div className="radioBtn" key={ind}>
                              <input
                                className="radio-input"
                                type="checkbox"
                                name="myradio-2"
                                id={"myradio3" + index}
                                value={_package.name}
                                checked={isAddPeople}
                                onChange={(e) =>
                                  handleChangeAddPeople(e, _package)
                                }
                              />
                              <label
                                htmlFor={"myradio3" + index}
                                className="radio__label"
                              >
                                <p>
                                  {_package.name}
                                  {planYearly === "Yearly"
                                    ? " Yearly "
                                    : " Monthly "}
                                  - ${price.price}
                                </p>
                              </label>
                            </div>
                          ))}
                      </div>
                    ))}

                  <div className="col-md-12 col-lg-6"></div>
                  {isAddPeople && (
                    <>
                      <div className="col-6 col-md-6 col-lg-3">
                        <input
                          type="name"
                          className="input-outline mt-2 mb-4"
                          placeholder="First Name"
                          value={peopleDetail.firstName}
                          name="firstName"
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-6 col-md-6 col-lg-3">
                        <input
                          type="name"
                          className="input-outline mt-2 mb-4"
                          placeholder="Last Name"
                          value={peopleDetail.lastName}
                          name="lastName"
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-12"></div>
                      {selectedPlan.packages
                        ?.filter(
                          (item) =>
                            item.add_on !== 0 &&
                            item.name !== "Additional Associate Coverage"
                        )
                        ?.map((item, index) => (
                          <div className="col-md-6 col-lg-4" key={index}>
                            {item.package_prices
                              ?.filter(
                                (item) => item.price_frequency === planYearly
                              )
                              .map((price, ind) => (
                                <div className="form-group">
                                  <input
                                    type="checkbox"
                                    name="cab_booking"
                                    id={"laterOne" + index}
                                    className="check-box-list"
                                    onChange={() =>
                                      handleCheckAddPeopleChange(item, index)
                                    }
                                    checked={checkedItemsAddPeople[index]}
                                  />
                                  <label
                                    htmlFor={"laterOne" + index}
                                    className="later-book book-name"
                                  >
                                    {item.name}
                                    {planYearly === "Yearly"
                                      ? " Yearly "
                                      : " Monthly "}
                                    - ${price.price}
                                  </label>
                                </div>
                              ))}
                          </div>
                        ))}
                    </>
                  )} */}
                      </div>
                    </div>
                    <div className="modal-footer billing-footer">
                      <button
                        type="button"
                        className="theme-button me-md-2 mb-2 login-button"
                        onClick={handleReview}
                      >
                        review changes
                      </button>
                      <button
                        type="button"
                        className="theme-button border-golden-1 login-button"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="account-login pt-5 px-0">
          {/* New Lifetime Package Section */}
          {isLoading && (
            <div className="loader">
              <ThreeDots
                height="110"
                width="110"
                radius="10"
                color="#aeaeae"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ display: 'contents' }}
                wrapperClassName=""
                visible={true}
              />
            </div>
          )}
          {!isLoading && (
            <div className="container-fluid">
              <div className="lifetime-package-wrapper">
                <div className="row">
                  {/* Main Package Card */}
                  <div className="col-lg-8">
                    <div className="package-card-main">
                      {/* Header Section */}
                      <div className="package-header">
                        <div className="header-content-left">
                          <h2 className="package-title">{packageTitle}</h2>
                          <span className="member-info">
                            {memberName} - Member since {memberSinceText} -
                            Membership ID: {membershipId}
                          </span>
                        </div>
                        <div className="header-content-right">
                          <span
                            className={
                              membershipStatus === 'Active'
                                ? 'active-badge'
                                : 'inactive-badge'
                            }
                          >
                            <span
                              className={
                                membershipStatus === 'Active'
                                  ? 'dot'
                                  : 'dot dot-inactive'
                              }
                            ></span>
                            {membershipStatus}
                          </span>
                          <div className="valid-info">
                            <span className="valid-label">Valid Thru:</span>
                            <span className="valid-date">{validThruText}</span>
                          </div>
                          <a
                            className="download-card-btn"
                            onClick={handleDownloadMembershipCard}
                          >
                            {isCardDownloading
                              ? 'Downloading...'
                              : 'Download ID Card →'}
                          </a>
                        </div>
                      </div>

                      {/* Find Range Section */}
                      <div className="find-range-section">
                        <div className="range-icon-wrapper">
                          <svg
                            className="location-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                              fill="#1A2A3F"
                            />
                          </svg>
                          <div className="range-text-content">
                            <h4 className="range-heading">
                              Find a Range & Book Your Visit
                            </h4>
                            <p className="range-description">
                              Access 127 partner ranges nationwide. Great for
                              travel – your member discount applies everywhere.
                            </p>
                          </div>
                        </div>
                        <div className="search-range-wrapper">
                          <input
                            type="text"
                            className="range-search-input"
                            placeholder="ZIP code or city..."
                            value={rangeSearchLocation}
                            onChange={(event) =>
                              setRangeSearchLocation(event.target.value)
                            }
                            onKeyDown={handleRangeSearchKeyDown}
                          />
                          <button
                            className="search-ranges-btn"
                            type="button"
                            onClick={handleRangeSearchRedirect}
                          >
                            Search Ranges
                          </button>
                        </div>
                      </div>

                      {/* Benefits Section */}
                      <div className="benefits-section">
                        <h5 className="benefits-heading">
                          INCLUDED WITH YOUR PLAN
                        </h5>
                        <div className="benefits-grid">
                          {mappedBenefits.map((benefit, index) => (
                            <div
                              className={
                                benefit.hasBadge
                                  ? 'benefit-item has-badge'
                                  : 'benefit-item'
                              }
                              key={benefit.id || `${benefit.name}-${index}`}
                            >
                              <div className="benefit-icon-wrapper">
                                <div className="box-icon">
                                  <i
                                    className={benefit.iconClass}
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <svg
                                  className="check-icon"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                >
                                  <circle
                                    cx="10"
                                    cy="10"
                                    r="10"
                                    fill="#4CAF50"
                                  />
                                  <path
                                    d="M5 10l3 3 7-7"
                                    stroke="white"
                                    strokeWidth="2"
                                    fill="none"
                                  />
                                </svg>
                              </div>
                              <div className="benefit-content">
                                {benefit.hasBadge ? (
                                  <div className="benefit-title-row">
                                    <h6 className="benefit-title">
                                      {benefit.name}
                                    </h6>
                                    <span className="full-card-badge">
                                      FULL CARD
                                    </span>
                                  </div>
                                ) : (
                                  <h6 className="benefit-title">
                                    {benefit.name}
                                  </h6>
                                )}
                                <p className="benefit-desc">
                                  {benefit.description}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="">
                      <div className="pane-bill">
                        <div className="history">
                          <h3 className="up-coming-bill mb-0">Reservations</h3>
                        </div>
                        <div className="d-flex align-items-center justify-content-between flex-wrap d-none">
                          <div className="row mb-3">
                            <div className="col-md-6 mb-3 mb-md-0">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Select Date"
                                value={bookingsDate}
                                onChange={handleBookingsDateChange}
                              />
                            </div>
                            <div className="col-md-6">
                              <select
                                className="form-select"
                                value={bookingsStatus}
                                onChange={handleBookingsStatusChange}
                              >
                                <option value="">Select Status</option>
                                <option value="Pending">Pending</option>
                                <option value="Scheduled">Scheduled</option>
                                <option value="Completed">Completed</option>
                                <option value="active">Active-Good</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="card bills-card bills-card-account mb-4">
                          <table className="amount-card mobile-responsive">
                            <thead>
                              <tr>
                                <th>BOOKING ID</th>
                                <th>RANGE NAME</th>
                                <th>START DATE & TIME</th>
                                <th>PARTICIPANTS</th>
                                <th>SKILL LEVEL</th>
                                <th>FIREARM</th>
                              </tr>
                            </thead>
                            <tbody>
                              {shouldShowBookingsLoader ? (
                                <tr>
                                  <td data-label="RANGE NAME" colSpan="6">
                                    <div className="d-flex justify-content-center py-3">
                                      <ThreeDots
                                        height="35"
                                        width="35"
                                        radius="9"
                                        color="#aeaeae"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                      />
                                    </div>
                                  </td>
                                </tr>
                              ) : bookingsError ? (
                                <tr>
                                  <td
                                    data-label="RANGE NAME"
                                    colSpan="6"
                                    className="text-center text-danger py-3"
                                  >
                                    {bookingsError}
                                  </td>
                                </tr>
                              ) : bookings.length > 0 ? (
                                bookings.map((item, index) => (
                                  <tr
                                    key={item?.id || item?.booking_id || index}
                                  >
                                    <td data-label="BOOKING">
                                      {item?.booking_id || item?.id || '--'}
                                    </td>
                                    <td data-label="RANGE NAME">
                                      {item?.range_name ||
                                        item?.range?.name ||
                                        item?.rangeName ||
                                        '--'}
                                    </td>
                                    <td data-label="START DATE & TIME">
                                      {formatBookingDate(item?.date)}{' '}
                                      {formatBookingTime(
                                        item?.time || item?.start_time
                                      )}
                                    </td>
                                    <td data-label="PARTICIPANTS">
                                      {getParticipantCount(item)}
                                    </td>
                                    <td data-label="SKILL LEVEL">
                                      {item?.skill_level ||
                                        item?.skillLevel ||
                                        '--'}
                                    </td>
                                    <td data-label="FIREARM">
                                      {item?.firearm || '--'}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    data-label="RANGE NAME"
                                    colSpan="6"
                                    className="text-center py-3"
                                  >
                                    No bookings found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {!bookingsError && bookingsTotal > 0 && (
                          <Pagination
                            itemsPerPage={BOOKINGS_PER_PAGE}
                            totalItems={bookingsTotal}
                            currentPage={bookingsPage}
                            onPageChange={handleBookingsPageChange}
                            disabled={bookingsLoading}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Sidebar */}
                  <div className="col-lg-4">
                    {/* Partner Spotlight */}
                    <div className="sidebar-card partner-spotlight">
                      <h6 className="sidebar-heading">PARTNER SPOTLIGHT</h6>
                      <div className="partner-content">
                        <div className="partner-title-row">
                          <div className="partner-logo-box">
                            <span className="partner-logo-text">USCCA</span>
                          </div>
                          <div className="partner-title-content">
                            <h5 className="partner-title">USCCA Partnership</h5>
                            <p>Exclusive member access</p>
                          </div>
                        </div>
                        <p className="partner-description">
                          Caliber Card members receive discounted coverage to
                          USCCA&apos;s self-defense liability coverage and
                          nationwide training programs.
                        </p>
                        <button className="partner-btn">
                          Explore USCCA Benefits
                        </button>
                      </div>
                    </div>

                    {/* Sponsored Section */}
                    <div className="sidebar-card sponsored-section">
                      <h6 className="sidebar-heading">SPONSORED</h6>
                      <div className="sponsored-content">
                        <div className="sponsored-logo-box">
                          <h6 className="sidebar-heading">PARTNER OFFER</h6>
                          <span className="sponsored-logo-text">Wiley-X</span>
                          <p className="sponsored-description">
                            Ballistic eyewear built for range and duty use. Full
                            Caliber Card members get 20% off storewide.
                          </p>
                          <button className="sponsored-btn">
                            Shop Wiley-X
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Membership Documents */}
                    <div className="sidebar-card membership-docs">
                      <h6 className="sidebar-heading">MEMBERSHIP DOCUMENTS</h6>
                      <ul className="docs-list">
                        <li>
                          <a
                            className="doc-link"
                            onClick={handleDownloadMembershipCard}
                          >
                            <span className="doc-link-text">
                              Membership ID Card{' '}
                              <span className="doc-type">(Download)</span>
                            </span>
                            <svg
                              className="chevron-icon"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6 12L10 8L6 4"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a href="#" className="doc-link">
                            <span className="doc-link-text">
                              Handgun Safety Guide{' '}
                              <span className="doc-type">(PDF)</span>
                            </span>
                            <svg
                              className="chevron-icon"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6 12L10 8L6 4"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a href="#" className="doc-link">
                            <span className="doc-link-text">
                              Plan Benefits Overview
                            </span>
                            <svg
                              className="chevron-icon"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M6 12L10 8L6 4"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </AccountMainLayout>
    </>
  );
};

export default AccountCoverage;
